/*
 * @Author: xxx xxx
 * @Date: 2023-01-31 10:25:11
 * @LastEditors: xxx xxx
 * @LastEditTime: 2023-02-28 13:59:51
 * @FilePath: \react-admin\src\divs\callback\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useNavigate } from "react-router-dom";
import "./index.less";
const PrizeCardAreaH5 = () => {
	const navigate = useNavigate();
	const gotoPrizeCardAreaH5 = () => {
		navigate("/prizeCardAreaH5");
	};
	return (
		<>
			<div className="box need-scroll-div">
				<div className="content">
					<div className="content-box" style={{ position: "relative" }}>
						<div
							onClick={() => gotoPrizeCardAreaH5()}
							style={{ position: "absolute", top: 350, right: 20, height: 50, width: 135, backgroundColor: "transparent" }}
						></div>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882363975369404416.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063425469853696.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063499474153472.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063568411734016.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063641010941952.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063707301916672.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063781054558208.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063860368846848.jpg"></img>
						<img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882340023116935168.jpg"></img>
						{/* <img src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882063994666266624.jpg"></img> */}
					</div>
				</div>
			</div>
		</>
	);
};
export default PrizeCardAreaH5;
